import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/* Hook used to extract query parameters from url */
export function useGetQueryParams() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }
  